import React from 'react';
import { Spin } from 'antd';
import { useHistory, useParams } from 'react-router-dom';

import { HtmlMarkdownContent } from '@components';
import { BlueButton } from '@share/components';
import { Routes } from '@share/constants';

import { useCertificateTerms } from '../hooks';

import styles from './styles.module.scss';

export const CertificateTermsWrapper: React.FC = () => {
  const history = useHistory();
  const { guid, accountUsername } = useParams<{ guid: string; accountUsername?: string }>();
  const { content, loading, error, refetch } = useCertificateTerms(guid);

  const certificatesPath = accountUsername
    ? `/${accountUsername}${Routes.Certificates}`
    : Routes.Certificates;

  const handleBackClick = (): void => {
    history.push(certificatesPath);
  };

  if (loading) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.stateBlock} role="status" aria-busy="true">
          <Spin size="large" />
        </div>
      </div>
    );
  }

  if (error || !content) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <a
            href={certificatesPath}
            className={styles.backLink}
            onClick={(event) => {
              event.preventDefault();
              handleBackClick();
            }}
          >
            Back to certificates
          </a>
          <div className={styles.stateBlock}>
            <p className={styles.errorText}>{error || 'Terms and conditions not found.'}</p>
            <BlueButton onClick={refetch}>Reload terms</BlueButton>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <a
          href={certificatesPath}
          className={styles.backLink}
          onClick={(event) => {
            event.preventDefault();
            handleBackClick();
          }}
        >
          Back to certificates
        </a>
        <h1 className={styles.title}>Terms and conditions</h1>
        <HtmlMarkdownContent content={content} className={styles.markdown} />
      </div>
    </div>
  );
};
